import { render } from "./ChatsView.vue?vue&type=template&id=5d6d06d4&ts=true"
import script from "./ChatsView.vue?vue&type=script&lang=ts"
export * from "./ChatsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__